import PropTypes from "prop-types"
import ReactSwitch from "react-switch"
import styled from "@emotion/styled"
import { useTheme } from "@emotion/react"
import { sizer, sizerNumber } from "@ninjaone/utils"
import Text from "./Text"

const StyledSwitchContainer = styled.div`
  display: grid;
  grid-template-columns: ${({ width }) => `${width}px auto`};
  grid-column-gap: ${sizer(2)};
  align-items: center;
  color: ${({ color }) => color};
`

const StyledLabel = styled.label`
  display: flex;
  align-items: center;
  margin: 0;
`

function getSize(size) {
  switch (size) {
    case "sm":
      return { width: sizerNumber(8), height: sizerNumber(4) }
    case "md":
      return { width: sizerNumber(10), height: sizerNumber(5) }
    case "lg":
      return { width: sizerNumber(12), height: sizerNumber(6) }
    default:
      throw new Error(`Unknown size: ${size}`)
  }
}

/**
 * Ninja switch component
 */
export default function Switch({ onChange, checked = false, labelToken, size = "md", disabled, isLegacy }) {
  const dimensions = getSize(size)
  const theme = useTheme()
  const onColor = isLegacy ? theme.color.action : theme.color.text
  const offColor = theme.color.gray
  return (
    <StyledSwitchContainer
      color={checked ? onColor : offColor}
      width={dimensions.width}
      data-test-id="switch-container"
    >
      <StyledLabel>
        <ReactSwitch
          {...{
            disabled,
            onChange,
            checked,
            checkedIcon: false,
            uncheckedIcon: false,
            offColor,
            onColor,
            ...dimensions,
          }}
        />
      </StyledLabel>
      <Text color="text" token={labelToken} size="sm" />
    </StyledSwitchContainer>
  )
}

Switch.propTypes = {
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  labelToken: PropTypes.string,
  size: PropTypes.oneOf(["sm", "md", "lg"]),
}
